export default __webpack_public_path__ + "2629eee136092c9132cc0dde2f6a7124.svg";